<template>
  <a :href="link" @click="handleClick" :class="['dropdown-item', 'd-flex', 'align-items-center']">
    <div class="notif-icon-wrap mr-3" :style="{ background: iconConfig.bg }">
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="notif-svg" v-html="iconConfig.path"></svg>
    </div>
    <div class="notif-body">
      <div class="font-weight-bold" v-html="localizedText"></div>
      <div class="small text-muted mt-1">{{ helpers.getDateDifference(parseDate(item.created_at)) }}</div>
    </div>
  </a>
</template>

<script>
  import moment from 'moment';

  const ICONS = {
    'points.new': {
      bg: '#fff8e1',
      path: `<path fill="#f59e0b" d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>`
    },
    'exams.schedule': {
      bg: '#e8f5e9',
      path: `<path fill="#43a047" d="M19 3h-1V1h-2v2H8V1H6v2H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2zm0 16H5V8h14v11zM7 10h5v5H7z"/>`
    },
    'lectures.changed': {
      bg: '#e3f2fd',
      path: `<path fill="#1e88e5" d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z"/>`
    },
    'messages.new': {
      bg: '#fce4ec',
      path: `<path fill="#e53935" d="M20 4H4a2 2 0 00-2 2v12a2 2 0 002 2h16a2 2 0 002-2V6a2 2 0 00-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>`
    },
    '_default': {
      bg: '#f3e5f5',
      path: `<path fill="#8e24aa" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>`
    },
  };

  export default {
    name: 'notification-item',

    props: ['item'],

    computed: {
      link() {
        return this.item.link || null;
      },

      iconConfig() {
        return ICONS[this.item.type] || ICONS['_default'];
      },

      localizedText() {
        if (this.$i18n.locale === 'en') {
          return this.item.text_eng || this.item.text;
        }
        return this.item.text;
      },
    },

    methods: {
      handleClick($event) {
        $event.stopPropagation();
        $event.preventDefault();
        this.$emit('seen', this.item);
      },

      parseDate(str) {
        return moment(str, 'YYYY-MM-DD HH:mm:ss.SSS');
      },
    }
  };
</script>

<style scoped>
  .dropdown-item {
    border-radius: 0 !important;
    padding: 0.75rem 1rem;
  }

  .dropdown-item:hover {
    font-family: inherit !important;
    background-color: rgba(192, 192, 192, 0.1);
  }

  .notif-icon-wrap {
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .notif-svg {
    width: 22px;
    height: 22px;
    display: block;
  }

  .notif-body {
    min-width: 0;
    flex: 1;
  }
</style>
